import React, { useState, useEffect } from 'react'
import { Container, Row, Column, Time, Label } from './Styled'
import PropTypes from 'prop-types'
import * as dateFns from 'date-fns'

export default function TarjaCountdown ({ to, onFinish, date }) {

	const [ now, setNow ] = useState(date)
	
	useEffect(() => {
	const interval = window.setInterval(() => {
		if (dateFns.differenceInSeconds(to, now) <= 0) {
		return onFinish()
		}
		setNow(dateFns.addSeconds(now, 1))
	}, 1000)

	return () => window.clearInterval(interval)
	}, [now])

	const countdown = getCountdown(to, now)

	return (
		<Container>
			<Row>
				<Column>
					<Time>{formatTime(countdown.day)}</Time>
					<Label>dias</Label>
				</Column>
				<Column>
					<Time>{formatTime(countdown.hour)}</Time>
					<Label>horas</Label>
				</Column>
				<Column>
					<Time>{formatTime(countdown.minute)}</Time>
					<Label>minutos</Label>
				</Column>
				<Column>
					<Time>{formatTime(countdown.second)}</Time>
					<Label>segundos</Label>
				</Column>
			</Row>
		</Container>
	)
}

TarjaCountdown.propTypes = {
	to: PropTypes.string.isRequired,
	onFinish: PropTypes.func.isRequired
}

function getCountdown (to, now) {
	let result = {}
	const parts = ['day', 'hour', 'minute', 'second']

	parts.forEach((p, i) => {
		let uP = p.charAt(0).toUpperCase() + p.slice(1)
		let t = dateFns[`differenceIn${uP}s`](to, now)
		if (t) {
			result[p] = t
			if (i < parts.length)
				to = dateFns[`sub${uP}s`](to, t)
		}
	})
  	return result
}

const formatTime = time => {
	if (!time) {
		return '00'
	}
	return time < 10 ? `0${time}` : time
}